import { AuthBody, LoginResponse } from '../models/AuthBody';
import cookieService, { COOKIE_KEYS } from './cookieService';
import downloadService from './downloadService';

export default {
  get token(): string {
    return cookieService.getItem<string>(COOKIE_KEYS.TOKEN);
  },

  set token(token: string) {
    cookieService.setItem(COOKIE_KEYS.TOKEN, token);
  },

  get refreshToken(): string {
    return cookieService.getItem<string>(COOKIE_KEYS.REFRESH_TOKEN);
  },

  set refreshToken(refreshToken: string) {
    cookieService.setItem(COOKIE_KEYS.REFRESH_TOKEN, refreshToken);
  },

  get currentUserId(): string {
    return cookieService.getItem<string>(COOKIE_KEYS.CURRENT_USER_ID);
  },

  set currentUserId(currentUserId: string) {
    cookieService.setItem(COOKIE_KEYS.CURRENT_USER_ID, currentUserId);
  },

  get hasJustRegistered(): string {
    return cookieService.getItem<string>(COOKIE_KEYS.HAS_JUST_REGISTERED);
  },

  set hasJustRegistered(hasJustRegistered: string) {
    cookieService.setItem(COOKIE_KEYS.HAS_JUST_REGISTERED, hasJustRegistered);
  },

  get shareableLinkToken(): string {
    return cookieService.getItem<string>(COOKIE_KEYS.SHAREABLE_LINK_TOKEN);
  },

  set shareableLinkToken(token: string) {
    cookieService.setItem(COOKIE_KEYS.SHAREABLE_LINK_TOKEN, token);
  },

  get rfiToken(): string {
    return cookieService.getItem<string>(COOKIE_KEYS.RFI_TOKEN);
  },

  set rfiToken(token: string) {
    cookieService.setItem(COOKIE_KEYS.RFI_TOKEN, token);
  },

  removeShareableLinkToken() {
    cookieService.removeItem(COOKIE_KEYS.SHAREABLE_LINK_TOKEN);
  },

  removeRfiToken() {
    cookieService.removeItem(COOKIE_KEYS.RFI_TOKEN);
  },

  saveTwoFa(twoFaProps: Omit<LoginResponse, 'token' | 'refreshToken'>) {
    cookieService.setItem(
      COOKIE_KEYS.IS_CONF_TFA,
      twoFaProps.isConfiguredTwoFactorAuth,
    );
    cookieService.setItem(COOKIE_KEYS.UID, twoFaProps.user._id);
    cookieService.setItem(COOKIE_KEYS.OT_PATH, twoFaProps.otpauth_url);
  },

  get twoFaProps(): any {
    return {
      [COOKIE_KEYS.IS_CONF_TFA]: cookieService.getItem<string>(
        COOKIE_KEYS.IS_CONF_TFA,
      ),
      [COOKIE_KEYS.OT_PATH]: cookieService.getItem<string>(COOKIE_KEYS.OT_PATH),
      [COOKIE_KEYS.UID]: cookieService.getItem<string>(COOKIE_KEYS.UID),
    };
  },

  removeHasJustRegistered() {
    cookieService.removeItem(COOKIE_KEYS.HAS_JUST_REGISTERED);
  },

  saveAuthBody({ token, refreshToken, user }: AuthBody) {
    cookieService.setItem(COOKIE_KEYS.TOKEN, token);
    cookieService.setItem(COOKIE_KEYS.REFRESH_TOKEN, refreshToken);
    cookieService.setItem(COOKIE_KEYS.CURRENT_USER_ID, user?._id);
  },

  removeAuthBody() {
    cookieService.removeItem(COOKIE_KEYS.TOKEN);
    cookieService.removeItem(COOKIE_KEYS.REFRESH_TOKEN);
    cookieService.removeItem(COOKIE_KEYS.CURRENT_USER_ID);
    downloadService.removeDownloadUniqueId();
    this.removeHasJustRegistered();
  },
};
